import { themeQuartz } from 'ag-grid-enterprise';
// ... Customise the default AG Grid here
const DEFAULT_THEME = themeQuartz.withParams({
    // ====== SELECTED ======
    selectedRowBackgroundColor: 'var(--color-gray-100)',
    rowHoverColor: 'var(--color-gray-50)',
    checkboxCheckedBackgroundColor: 'var(--color-fortem-orange)',
    // ====== BORDERS ======
    wrapperBorder: 'none',
    headerRowBorder: '1px solid var(--border)',
    headerColumnBorder: '1px solid var(--border)',
    // ====== BACKGROUNDS ======
    headerBackgroundColor: 'var(--sidebar)',
    // ====== TYPOGRAPHY ======
    fontFamily: 'var(--default-font-family)',
    fontSize: 'var(--text-xs)',
    headerFontWeight: 500,
    headerTextColor: 'var(--color-heading)',
    buttonFontWeight: 400,
    // ====== BORDER RADIUS ======
    borderRadius: 'var(--radius)',
    inputBorderRadius: 'calc(var(--radius) - 2px)',
    wrapperBorderRadius: 0,
    checkboxBorderRadius: 'calc(var(--radius-sm) - 2px)',
    // ====== MENUS ======
    menuBackgroundColor: 'white',
    menuBorder: '1px solid var(--border)',
    menuSeparatorColor: 'var(--border)',
    menuShadow: 'var(--shadow-md)',
    // ====== SPACING ======
    spacing: 6,
    widgetHorizontalSpacing: 10,
    widgetVerticalSpacing: 10,
    widgetContainerVerticalPadding: 12,
    widgetContainerHorizontalPadding: 12,
    rowVerticalPaddingScale: 0.7,
    headerVerticalPaddingScale: 0.7,
});
export default DEFAULT_THEME;
